import React from 'react';
import { RouteObject } from 'react-router';

const TemplateListPage = React.lazy(() =>
  import('./pages/list').then((module) => ({ default: module.TemplateListPage }))
);

export const routes: RouteObject[] = [
  {
    path: 'template',
    element: <TemplateListPage />,
  },
];
